"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsPasskeySupported = void 0;
const react_native_1 = require("@aws-amplify/react-native");
const getIsPasskeySupported = () => {
    return (0, react_native_1.loadAmplifyRtnPasskeys)().getIsPasskeySupported();
};
exports.getIsPasskeySupported = getIsPasskeySupported;
